import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

export interface PageHeaderProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
  tabs?: React.ReactNode
}

/**
 * PageHeader - Header unificat pentru toate paginile
 * 
 * Rezolvă problemele:
 * - Titluri duple în pagini cu tab-uri
 * - Inconsistențe în styling-ul header-elor
 * - Spacing neuniform între elemente
 * 
 * Features:
 * - Titlu principal standardizat (H1)
 * - Breadcrumbs opționale  
 * - Actions în dreapta (butoane, filtre)
 * - Tab-uri integrate
 * - Subtitle opțional
 * - Divider opțional
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  actions,
  tabs,
}) => {
  const theme = useTheme()
  const { designSystem } = theme
  const colors = theme.palette.mode === 'dark' 
    ? designSystem.colors.dark 
    : designSystem.colors.light

  // Cerință UI: nu mai afișăm numele paginii sub top bar (ex: "Studii", etc.)
  // Păstrăm doar actions/tabs dacă există.
  if (!actions && !tabs) return null

  return (
    <Box>
      {/* Actions row (fără titlu pagină) */}
      {actions && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            px: 2,
            py: 0.5,
            backgroundColor: colors.background.default,
            borderBottom: `1px solid ${colors.border.default}`,
          }}
        >
          {actions}
        </Box>
      )}

      {/* Tabs section - direct sub title, fără spațiu */}
      {tabs && (
        <Box
          sx={{
            backgroundColor: colors.background.paper,
            borderBottom: `1px solid ${colors.border.default}`,
          }}
        >
          <Box
            sx={{
              paddingLeft: 0, // Tab-urile încep de la marginea stângă
              paddingRight: 0,
            }}
          >
            {tabs}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default PageHeader
